import { NameRuler, PasswordRuler, PhoneCubaNumberRuler } from '@dofleini/validator';
import { authentication } from '@/settings';
import { renderAvatarSection } from '@/modules/admin/components/UserDetailContent/AvatarSection';
import renderAvatarViewWidget from '@/components/UserAvatar/renderAvatarViewWidget';
import createFormFieldset from '@/utils/createFormFieldset';
import UserRoles  from '@/modules/admin/components/UserRoles';
import { renderFieldPassword } from '@/modules/admin/components/FieldPassword';
import { createSearchFieldRemote } from '@/utils/createSearchFieldRemote';
import { useSearchRol } from '@/modules/admin/hooks/useSearchRol';
import createClearRenderView from '@/utils/createClearRenderView';
import { renderUserTypes, userTypesOptions } from '@/utils/selectsUtils';
import MunicipalityAHABSelect from '@/modules/utils/components/MunicipalityAHABSelect';
import i18n from 'i18next';

export const baseFields = [
  {
    key: 'avatar',
    colSpan: 2,
    onlyView: true,
    renderView: renderAvatarViewWidget
  },
  {
    key: 'avatar',
    colSpan: 2,
    // eslint-disable-next-line react/display-name
    render: renderAvatarSection,
    onlyEdit: true,
    label: 'user.form.avatar.placeholder'
  },
  {
    key: 'clientType',
    label: 'user.form.clientType',
    required: true,
    colSpan: 2,
    widget: 'select',
    options: userTypesOptions,
    renderView: renderUserTypes
  },
  {
    key: 'firstName',
    colSpan: 2,
    label: 'user.form.firstName.placeholder',
    placeholder: 'defaultPlaceholder',
    required: true,
    renderView: createClearRenderView(),
    rules: [NameRuler]
  },
  {
    key: 'phone',
    colSpan: 1,
    renderView: createClearRenderView(),
    label: 'user.form.phone.placeholder',
    rules: [PhoneCubaNumberRuler]
  },
  {
    key: 'email',
    colSpan: 1,
    label: 'user.form.email.placeholder',
    renderView: createClearRenderView(),
    rules: [{ required: true }, { type: 'email' }],
  },
  {
    key: 'address.municipality',
    colSpan: 2,
    label: 'user.form.municipality.placeholder',
    widget: MunicipalityAHABSelect,
    required: true,
  },
];

const fields = [
  ...baseFields,
  {
    key: 'security',
    colSpan: 2,
    render: createFormFieldset({ title: 'user.form.security', translation: 'admin' }),
  },
  {
    key: 'roles',
    colSpan: 2,
    label: 'user.form.roles',
    widget: createSearchFieldRemote({
      usePagination: useSearchRol,
      translation: 'admin',
      mapResponse: (roles) => {
        return roles.map(role => {
          const roleName = role?.name;
          const exist = i18n.exists(`admin:rol.${roleName}`);
          const title = exist ? i18n.t(`admin:rol.${roleName}`) : roleName;
          return {
            ...role,
            name: title,
          };
        });
      },
      mode: 'multiple',
      fullEntity: true
    }),
    initialValue: [],
    viewWidget: UserRoles,
  },
  {
    key: 'createdAt',
    label: 'registerAt',
    type: 'date',
    onlyView: true
  },
  {
    key: 'password',
    label: 'setNewPassword',
    colSpan: 2,
    onlyEdit: true,
    widget: renderFieldPassword,
    rules: [PasswordRuler]
  },
];

if (authentication.showAddress) {
  fields.push(
    {
      key: 'address',
      colSpan: 2,
      label: 'USER.FORM.ADDRESS.PLACEHOLDER'
    }
  );
}

export { fields };
